export const baseURL1 = 'https://api.egasi.net/api'
export const uploadDataUrl = 'https://api.egasi.net/api'
// export const baseURL1 = 'http://localhost:1335/api'
// export const baseURL1 = 'https://theapi.egasi.net/api'
// export const baseURL1 = 'http://localhost:8100/api'

export const realEstateId = "638f25154cb7c29ec6ad4bfe"
export const vehicleId = "638f1fd34cb7c29ec6ad4bd6"
